/* eslint-disable @typescript-eslint/no-explicit-any */
import { useToastContext } from "../../../../common/components/ui/toast/toast.context"
import { Modal } from "flowbite-react"
import ButtonWithLoader from "../../../../common/components/ui/loading/ButtonLoading"
import { useFormik, FormikProvider } from "formik"
import TextareaFormik from "../../../renters/components/forms/TextareaFormik"
import { chargesDendDispute } from "../../../../common/services/charges.api"

type Props = {
    data: any | null
    onChance(data: any): void
    onClose: () => void
}

export default function ModalDisputeInvoice(props: Props) {
    const { showToast } = useToastContext()
    const formik = useFormik({
        initialValues: {
            ...props.data
        },
        onSubmit: async (values) => {
            await saveDisputeInvoice(values);
        },
        // validate: (values) => {
        //     const errors: Record<string, string> = {};
        //     if (!values.cnpj) errors.cnpj = "CNPJ obrigatório";
        //     return errors;
        // }
    });

    const notifySuccess = (text) => showToast({ text, type: 'success' })
    const notifyError = (text) => showToast({ text, type: 'error' })
    const handleCloseModal = () => { props.onClose() }

    async function saveDisputeInvoice(data: any) {
        try {
            const result =  await chargesDendDispute(data._id, data.contest.message);

            if( !result.ok) 
                return notifyError(result.message || 'Erro ao tentar contestar fatura, tente novamente');
            
            data.contest.status = "closed";
            props.onChance(data);
            notifySuccess('Salvando cliente...');
            props.onClose();
        } catch (err) {
            notifyError('Erro ao tentar salvar cliente, tente novamente');
        }
    }

    return (
        <Modal
            size={'5xl'}
            className='relative'
            show={true}
            onClose={() => handleCloseModal()}
        >
            <Modal.Header className='text-black'>
                <div className="flex items-center justify-start gap-3 text-black">
                    <span className="font-semibold text-lg text-justify">
                        Contestar Fatura
                    </span>
                    {props.data?.notes && (
                        <span className="ml-2 text-gray-500 text-base text-justify">
                            {props.data.notes || "Sem observações"}
                        </span>
                    )}
                </div>
            </Modal.Header>
            <Modal.Body className='w-full relative border-gray flex flex-col text-black' style={{ minHeight: 'calc(50vh - 300px)', height: 'calc(100vh - 300px)' }}>
                <form onSubmit={formik.handleSubmit}>
                    <FormikProvider value={formik}>
                        <section className="max-w-4xl mx-auto" >
                            <div className="gap-2 mb-4">
                                <div className="">
                                    <TextareaFormik
                                        label="Observação"
                                        name="contest.message"
                                        className="w-full h-full min-h-[10rem] flex-1 rounded shadow-md focus:border-white resize-none"
                                    />
                                </div>
                            </div>
                        </section>
                        <div className="w-full flex justify-end">
                            <ButtonWithLoader
                                isLoading={formik.isSubmitting}
                                disabled={!formik.isValid}
                                type="submit"
                            >
                                Enviar Contestação
                            </ButtonWithLoader>
                        </div>
                    </FormikProvider >
                </form >
            </Modal.Body>
        </Modal>
    );
}
